// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const supportsSessionStorage = () => {
  try {
    return !!window.sessionStorage;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getItem = (name: string) => {
  if (!supportsSessionStorage()) {
    return null;
  }

  try {
    const value = window.sessionStorage.getItem(name);

    try {
      // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
      return JSON.parse(value);
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return value;
    }
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const saveItem = (name: string, value: any) => {
  if (!supportsSessionStorage()) {
    return false;
  }

  const toSave = typeof value !== "string" ? JSON.stringify(value) : value;

  try {
    window.sessionStorage.setItem(name, toSave);
    return true;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const removeItem = (name: string) => {
  if (!supportsSessionStorage()) {
    return false;
  }

  try {
    window.sessionStorage.removeItem(name);
    return true;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
};
